function mediacenterQuickView() {
    const infoLink = document.getElementById('Download-Info-Link');
    if (!infoLink) {
      console.log('Download-Info-Link not found');
      return;
    }
    
    infoLink.addEventListener('click', (event) => {
      event.preventDefault();
      const variantId = infoLink.dataset.variantId;

      const params = new URLSearchParams();
      params.append("variantId", variantId);
      params.append("locale", window.Shopify.locale);
      params.append("country", window.Shopify.country);

      fetch(window.Shopify.routes.root + `apps/de-berkel/info?${params}`)
      .then((response) => {
        if (!response.ok) {
          throw new Error('Network response was not ok');
        }
        
        // Extract filename from Content-Disposition header
        const contentDisposition = response.headers.get('Content-Disposition');

        console.log(contentDisposition);
        let filename = 'download.txt'; // Default filename
        if (contentDisposition) {
          const filenameMatch = contentDisposition.match(/filename="?(.+?)"?$/);
          if (filenameMatch) {
            filename = filenameMatch[1];
          }
        }
        
        return response.blob().then(blob => ({ blob, filename }));
      })
      .then(({ blob, filename }) => {
        // Create a temporary URL for the blob
        const url = window.URL.createObjectURL(blob);
        
        // Create a temporary anchor element and trigger download
        const a = document.createElement('a');
        a.href = url;
        a.download = filename;
        document.body.appendChild(a);
        a.click();
        
        // Clean up
        document.body.removeChild(a);
        window.URL.revokeObjectURL(url);
        
        console.log('Download initiated:', filename);
      })
      .catch((error) => {
        console.error("Error:", error);
      });
    });
  
  }
  
  // Listen for the quick-view:loaded event
  document.addEventListener('quick-view:loaded', (event) => {
    mediacenterQuickView();
  });
  
    // Listen for the quick-view:loaded event
    document.addEventListener('variant:changed', (event) => {
        mediacenterQuickView();
      });

  
  